// import Vue from 'vue'

import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex'

import Axios from 'axios'
// import VueAxios from 'vue-axios'

var token = document.getElementsByName('csrf-token')[ 0 ].getAttribute('content')
const axios = Axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Credentials': 'same-origin',
    'Accept': 'application/json',
    'X-CSRF-Token': token
  }
})

// Vue.use(VueAxios, axios)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selected_video_id: null,
    tags: [],
    videos: [],
    active_tags: []
  },
  getters: {
    tags: state => state.tags,
    active_tag: (state) => (tag_id) => state.active_tags.find((a) => a == tag_id ),
    videos: state => state.videos,
    selected_video: (state) => {
      if (state.selected_video_id == null) return null

      return state.videos.find((v) => v.id == state.selected_video_id)
    },
    selected_videos (state) {
      if (state.active_tags.length == 0) return state.videos

      return state.videos.filter((v) => {
        return state.active_tags.every(e => v.tags.find(v => v.id == e))
      })
    }
  },
  mutations: {
    toggle_tag (state, tag_id) {
      let found = state.active_tags.find( t => t == tag_id)
      if (found) {
        state.active_tags.splice(state.active_tags.indexOf(found), 1)
      } else {
        state.active_tags.push(tag_id)
      }
    },
    set_tags (state, data) { state.tags = data },
    set_videos (state, data) { state.videos = data },
    set_select_video (state, data) { state.selected_video_id = data }
  },
  actions: {
    async fetchStartup (context) {
      await axios.get('startup')
        .then((response) => {
          context.commit('set_tags', response.data.tags)
          context.commit('set_videos', response.data.videos)
        })
    },
    toggle_tag(context, tag_id) {
      context.commit('toggle_tag', tag_id)
    },
    select_video(context, video_id) {
      context.commit('set_select_video', video_id)
    }
  }
})
